<template>
    <div>
        <compWrapper
            :title="
                activityTypeName != ''
                    ? '促销类型-' + activityTypeName
                    : '活动信息'
            "
            theme="primary"
        >
            <div
                v-if="type != 'query' && activityType == 2"
                style="
                    color: red;
                    margin-left: 102px;
                    margin-top: 10px;
                    font-size: 18;
                "
            >
                提示：
                1、普通活动开始时间为当前日期3天后，以美西时间为准，最长四周。
                <div style="margin-left: 40px">
                    2、普通活动折扣为10%~50%，大促折扣为15%~50%。
                </div>
            </div>
            <compFormQuery
                v-if="type == 'query'"
                :formdata="getBase"
                :value="formData"
                :labelWidth="120"
            ></compFormQuery>
            <compFormEdit
                v-else
                class="margin-15 clearfix"
                ref="editform"
                :formdata="getBase"
                v-model="formData"
                :labelWidth="120"
            />
            <div v-if="type != 'query'" class="text-right margin-right-15">
                <!-- <vButton theme="primary" @click="submit(0)">保存为草稿</vButton> -->
                <vButton
                    class="margin-left-10"
                    theme="success"
                    @click="submit(0)"
                    >保存并提交</vButton
                >
                <vButton class="margin-left-10" @click="cancel">{{
                    $t("global.common.operate_cancel", { defaultValue: "取消" })
                }}</vButton>
            </div>
        </compWrapper>
        <compWrapper
            v-if="type == 'query'"
            :title="
                $t('global.common.operation_history', {
                    defaultValue: '操作历史',
                })
            "
            theme="gray"
        >
            <vTableSimple
                v-if="type == 'query'"
                class="margin-15"
                :columns="getColumns"
                :data="getData"
                :loading="logLoading"
                border
            ></vTableSimple>
        </compWrapper>
        <div v-show="modalProps.show" class="custom-modal">
            <div class="modal-overlay" @click="closeModal"></div>

            <div class="modal-content">
                <div
                    class="enhanced-zoom-container"
                    @wheel.prevent="handleWheel"
                    @mousedown="startDrag"
                    ref="container"
                >
                    <div class="image-wrapper" :style="transformStyle">
                        <img
                            :src="modalProps.url"
                            alt="可缩放拖动图片"
                            class="zoomable-image"
                            draggable="false"
                            @dragstart.prevent
                        />
                    </div>
                    <div class="controls">
                        <button @click="resetZoom">重置</button>
                        <span>缩放: {{ (scale * 100).toFixed(0) }}%</span>
                        <button @click="closeModal" class="close-button">
                            关闭
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <!-- 添加全局的liading -->
        <vLoading size="large" transfer fix :loading="loading"></vLoading>
    </div>
</template>

<script>
import { mapGetters } from "vuex";

import {
    HttpGetActivityProcessOne,
    HttpSaveActivityProcess,
    HttpGetLogList,
    HttpGetMovementTypeProps,
    HttpGetActivityProcessOneByManagement,
} from "@/service/products/activityProcess";
export default {
    props: ["activeids", "querytype"],
    components: {
        compWrapper: () => import("@components/templates/wrapper"),
        compFormQuery: () => import("@components/templates/formquery"),
        compFormEdit: () => import("@components/templates/formedit"),
    },
    data() {
        return {
            scale: 1,
            isDragging: false,
            offset: { x: 0, y: 0 },
            startPos: { x: 0, y: 0 },
            id: this.$route.query.id,
            activityType: this.$route.query.sourceType,
            activityTypeName: "",
            type: this.$route.params.type,
            formData: {
                status: 0,
                cancelStatus: 0,
                hostOrgId: "",
                channelId: "",
                channelFlag: "",
                movementType: 0,
            },
            logLoading: false,
            docList: [],
            logList: [],
            movementTypeProps: [],
            movementTypeData: {
                dateOptions: 1,
                dateRange: "",
                name: "普通活动",
                value: 0,
            },
            loading: false,
            modalProps: {
                show: false,
                title: this.$t("global.photo.info", {
                    defaultValue: "图片信息",
                }),
                footerHide: true,
                width: 1236,
                zIndex: 9999,
                url: "",
            },
        };
    },
    created() {
        this.update();
        this.getMovementTypeProps();
        if (this.activityType == 0) {
            this.activityTypeName = "Coupon";
        } else if (this.activityType == 1) {
            this.activityTypeName = "Price Discount";
        } else if (this.activityType == 2) {
            this.activityTypeName = "Best Deal";
        } else if (this.activityType == 3) {
            this.activityTypeName = "LD";
        }
    },
    computed: {
        ...mapGetters("diction", ["getNewProductList", "getNewAccountIdList"]),
        getBase() {
            let showquery = this.type == "query";
            let edit = this.type == "edit";
            let add = this.type == "add";
            let ld = this.activityType == 3;
            let bd = this.activityType == 2;
            let pd = this.activityType == 1;
            let cp = this.activityType == 0;
            return [
                {
                    label: "ASIN:",
                    key: "asin",
                    tag: "div",
                    show: add,
                    children: (h) => {
                        return h("compErpSkuAndAsinInput", {
                            props: {
                                value: this.formData.asin,
                            },
                            on: {
                                "on-data": (row) => {
                                    this.$set(
                                        this.formData,
                                        "channelFlag",
                                        row.accountFlag
                                    );
                                    this.$set(this.formData, "asin", row.asin);
                                },
                            },
                        });
                    },
                    style: {
                        height: "32px",
                    },
                },
                {
                    label: "ASIN:",
                    key: "asin",
                    show: edit || showquery,
                    props: {
                        disabled: true,
                    },
                },
                {
                    label: "店铺:",
                    key: "channelFlag",
                    props: {
                        disabled: true,
                    },
                },
                {
                    label: "促销类型:",
                    key: "activityType",
                    show: showquery,
                    tag: "vSelect",
                    options: [
                        {
                            value: 0,
                            label: "Coupon",
                        },
                        {
                            value: 1,
                            label: "Price Discount",
                        },
                        {
                            value: 2,
                            label: "Best Deal",
                        },
                        {
                            value: 3,
                            label: "LD",
                        },
                    ],
                },
                {
                    label: "活动类型:",
                    key: "movementType",
                    show: ld || bd,
                    tag: "vSelect",
                    props: {
                        filterable: true,
                    },
                    options: this.movementTypeProps.map((item) => {
                        return {
                            value: item.value,
                            label: item.name,
                        };
                    }),
                    on: {
                        "on-change": (val) => {
                            this.handleMovementTypeChange(val);
                        },
                    },
                },
                {
                    label: "活动类型:",
                    show: showquery,
                    render: (h) => {
                        if (this.formData.movementType == 0) {
                            return (
                                <span>{this.formData.movementTypeName}</span>
                            );
                        } else {
                            return (
                                <span style="color: red;">
                                    {this.formData.movementTypeName}
                                </span>
                            );
                        }
                    },
                },
                {
                    label: "活动名称:",
                    show: cp || showquery,
                    key: "promotionName",
                },
                {
                    label: "优惠券名称:",
                    show: cp || showquery,
                    key: "couponName",
                },
                {
                    label: "活动开始时间:",
                    key: "beginTime",
                    show: this.movementTypeData.dateOptions == 1,
                    tag: "vDatepicker",
                    props: {
                        placeholder: "Select date",
                        format: "yyyy-mm-dd",
                        confirm: false,
                    },
                    on: {
                        "on-change": (val) => {
                            this.handleDateTwoChange(
                                val,
                                this.movementTypeData.value
                            );
                        },
                    },
                },
                {
                    label: "活动结束时间:",
                    key: "endTime",
                    show: !ld && this.movementTypeData.dateOptions == 1,
                    tag: "vDatepicker",
                    props: {
                        placeholder: "Select date",
                        format: "yyyy-mm-dd",
                        confirm: false,
                    },
                },
                {
                    label: "活动开始时间:",
                    key: "beginTime",
                    show: this.movementTypeData.dateOptions == 3,
                    tag: "vDatepicker",
                    props: {
                        placeholder: "Select date",
                        format: "yyyy-mm-dd",
                        confirm: false,
                    },
                    on: {
                        "on-change": (val) => {
                            this.handleDateChange(
                                val,
                                this.movementTypeData.dateOptions
                            );
                        },
                    },
                    formItem: {
                        labelWidth: 120,
                        tip: `<div class="color-error">${
                            "请在" +
                            this.movementTypeData.startDate +
                            "~" +
                            this.movementTypeData.endDate +
                            "范围内选择日期！"
                        }</div>`,
                    },
                },
                {
                    label: "活动结束时间:",
                    key: "endTime",
                    show: !ld && this.movementTypeData.dateOptions == 3,
                    tag: "vDatepicker",
                    props: {
                        placeholder: "Select date",
                        format: "yyyy-mm-dd",
                        confirm: false,
                    },
                    on: {
                        "on-change": (val) => {
                            this.handleDateChange(
                                val,
                                this.movementTypeData.dateOptions
                            );
                        },
                    },
                    formItem: {
                        labelWidth: 120,
                        tip: `<div class="color-error">${
                            "请在" +
                            this.movementTypeData.startDate +
                            "~" +
                            this.movementTypeData.endDate +
                            "范围内选择日期！"
                        }</div>`,
                    },
                },
                {
                    label: "优惠预算:",
                    show: cp || showquery,
                    key: "discountedBudget",
                },
                {
                    label: "折扣形式:",
                    key: "discountType",
                    show: pd || ld || cp || showquery,
                    tag: "vSelect",
                    options: [
                        {
                            value: 0,
                            label: "百分比",
                        },
                        {
                            value: 1,
                            label: "固定金额",
                        },
                    ],
                },
                {
                    label: "金额折扣",
                    show: bd,
                    key: "unitAmount",
                },
                {
                    label: "金额/百分比:",
                    show: pd || ld || cp || showquery,
                    key: "unitAmount",
                },
                {
                    label: "折扣前价格:",
                    show: bd || showquery,
                    key: "priceBeforeDiscount",
                },
                {
                    label: "折扣后价格:",
                    show: bd || showquery,
                    key: "priceAfterDiscount",
                },
                {
                    label: "实际折扣金额(or%):",
                    show: showquery,
                    key: "actualDiscountAmount",
                },
                {
                    label: "实际折扣后价格:",
                    show: showquery,
                    key: "actualDiscountedPrice",
                },
                {
                    label: "Promation ID:",
                    show: showquery,
                    key: "promationId",
                },
                {
                    label: "Agreement ID:",
                    show: showquery,
                    key: "agreementId",
                },
                {
                    label: "数量:",
                    show: ld || showquery || bd,
                    key: "quantity",
                },
                {
                    label: "客户是否可领取多次优惠券:",
                    show: cp || showquery,
                    key: "oncePerCustomer",
                    tag: "vSelect",
                    options: [
                        {
                            value: 0,
                            label: "否",
                        },
                        {
                            value: 1,
                            label: "是",
                        },
                    ],
                },
                {
                    label: "优惠券分发方式:",
                    show: cp || showquery,
                    key: "couponDistribution",
                },
                {
                    label: "备注",
                    key: "remark",
                    tag: "vTextarea",
                    required: false,
                },
            ];
        },
        getData() {
            return this.logList;
        },
        getColumns() {
            return [
                {
                    title: this.$t("global.common.operate_time"),
                    key: "createdAt",
                    width: 150,
                },
                {
                    title: this.$t("global.common.operator"),
                    key: "createdName",
                    width: 120,
                },
                {
                    title: this.$t("global.common.operate_remark", {
                        defaultValue: "备注",
                    }),
                    key: "remark",
                    width: 300,
                },
                {
                    title: "图片",
                    key: "pictures",
                    render: (h, { row }) => {
                        if (row.pictures) {
                            let pictures = row.pictures.split(",");
                            let img = [];
                            pictures.map((item) => {
                                img.push(
                                    <div
                                        style="float: left; cursor: pointer; margin-right: 10px;"
                                        onClick={this.openModal.bind(
                                            this,
                                            item
                                        )}
                                    >
                                        <img
                                            style="width: 100px; height: 100px;"
                                            src={item}
                                        />
                                    </div>
                                );
                            });
                            return (
                                <div style="padding: 10px 0; overflow: hidden;">
                                    {img}
                                </div>
                            );
                        } else {
                            return (
                                <div style="padding: 10px 0; overflow: hidden;">
                                    <span>无</span>
                                </div>
                            );
                        }
                    },
                },
            ];
        },
        transformStyle() {
            return {
                transform: `translate(${this.offset.x}px, ${this.offset.y}px) scale(${this.scale})`,
                cursor: this.isDragging ? "grabbing" : "grab",
            };
        },
    },
    methods: {
        handleDateChange(val, dateOptions) {
            if (!this.isDateInRange(val) && dateOptions == 3) {
                this.$Message.error(
                    "请在" +
                        this.movementTypeData.startDate +
                        "~" +
                        this.movementTypeData.endDate +
                        "范围内选择日期！"
                );
                return;
            }
        },
        handleDateTwoChange(beginTime, value) {
            if (
                this.activityType == 2 &&
                this.formData.movementType == 0 &&
                value == 0
            ) {
                const pstTime = this.getCurrentPSTTime();
                const now = new Date(pstTime);
                const valc = new Date(beginTime);
                const hours = now.getHours();
                const minutes = now.getMinutes();
                // 判断是否在23:30之前
                const isBefore2330 =
                    hours < 23 || (hours === 23 && minutes < 30);
                // 计算推后的天数
                const daysToAdd = isBefore2330 ? 2 : 3;
                // 计算可选日期
                const futureDate = new Date(
                    now.setDate(now.getDate() + daysToAdd)
                );
                const futureDateA = this.formatDate(futureDate);
                const vala = this.formatDate(valc);
                if (vala <= futureDateA) {
                    this.$Message.error(
                        "开始时间请选择" + futureDateA + "以后的日期！"
                    );
                    return;
                }
            }
        },
        handleDateTwoChangeA() {
            if (
                this.formData.activityType == 2 &&
                this.formData.movementType == 0 &&
                this.movementTypeData.value == 0
            ) {
                const pstTime = this.getCurrentPSTTime();
                const now = new Date(pstTime);
                const valc = new Date(this.formData.beginTime);
                const hours = now.getHours();
                const minutes = now.getMinutes();
                // 判断是否在23:30之前
                const isBefore2330 =
                    hours < 23 || (hours === 23 && minutes < 30);
                // 计算推后的天数
                const daysToAdd = isBefore2330 ? 2 : 3;
                // 计算可选日期
                const futureDate = new Date(
                    now.setDate(now.getDate() + daysToAdd)
                );
                const futureDateA = this.formatDate(futureDate);
                const vala = this.formatDate(valc);
                if (vala <= futureDateA) {
                    this.$Message.error(
                        "开始时间请选择" + futureDateA + "以后的日期！"
                    );
                    return false; // 验证失败
                }
            }
            return true; // 验证通过
        },
        formatDate(date) {
            const year = date.getFullYear();
            const month = String(date.getMonth() + 1).padStart(2, "0");
            const day = String(date.getDate()).padStart(2, "0");
            return `${year}-${month}-${day}`;
        },
        getCurrentPSTTime() {
            const now = new Date();
            return now.toLocaleString("en-US", {
                timeZone: "America/Los_Angeles",
                hour12: false,
            });
        },
        handleMovementTypeChange(val) {
            this.movementTypeProps.forEach((item) => {
                if (item.value == val) {
                    this.movementTypeData = item;
                }
            });
        },
        isDateInRange(date) {
            //比较日期大小函数
            const selected = new Date(date);
            const start = new Date(this.movementTypeData.startDate);
            const end = new Date(this.movementTypeData.endDate);
            return selected >= start && selected <= end;
        },
        getMovementTypeProps() {
            HttpGetMovementTypeProps({}).then(
                (res) => {
                    this.movementTypeProps = res.data;
                },
                (err) => {
                    this.$VMessage.error({
                        content: err.message,
                        duration: 30,
                        closable: true,
                    });
                }
            );
        },
        handleWheel(e) {
            const delta = e.deltaY > 0 ? -0.1 : 0.1;
            this.scale = Math.max(0.1, this.scale + delta);
        },
        startDrag(e) {
            e.preventDefault();
            this.isDragging = true;
            this.startPos = {
                x: e.clientX - this.offset.x,
                y: e.clientY - this.offset.y,
            };
            document.addEventListener("mousemove", this.handleDrag);
            document.addEventListener("mouseup", this.stopDrag);
        },
        handleDrag(e) {
            if (!this.isDragging) return;
            this.offset.x = e.clientX - this.startPos.x;
            this.offset.y = e.clientY - this.startPos.y;
        },
        stopDrag() {
            this.isDragging = false;
            document.removeEventListener("mousemove", this.handleDrag);
            document.removeEventListener("mouseup", this.stopDrag);
        },
        resetZoom() {
            this.scale = 1;
            this.offset = { x: 0, y: 0 };
        },
        closeModal() {
            this.modalProps.show = false;
            this.resetZoom();
        },
        openModal(url) {
            this.modalProps.url = url;
            this.modalProps.show = true;
        },
        async update() {
            if (this.type == "add") return;
            if (this.activeids) {
                this.id = this.activeids.id;
                this.type = this.querytype;
            } else {
                this.id = this.id;
                this.type = this.type;
            }
            if (this.type == "query") {
                HttpGetLogList({
                    search: {
                        EQ_opDataId: this.id,
                    },
                }).then(
                    (res) => {
                        this.logList = res.data.content;
                    },
                    (err) => {
                        this.$VMessage.error(err.message);
                    }
                );
            }
            if (this.type == "edit" || this.activeids.type == "customer") {
                HttpGetActivityProcessOne({
                    id: this.id,
                }).then(
                    (res) => {
                        this.formData = res.data;
                        this.docList = res.data.pictures
                            ? JSON.parse(res.data.pictures).items
                            : [];
                    },
                    (err) => {
                        this.loading = false;
                        this.$VMessage.error({
                            content: err.message,
                            duration: 30,
                            closable: true,
                        });
                    }
                );
            } else if (this.activeids.type == "management") {
                HttpGetActivityProcessOneByManagement({
                    id: this.id,
                }).then(
                    (res) => {
                        this.formData = res.data;
                        this.docList = res.data.pictures
                            ? JSON.parse(res.data.pictures).items
                            : [];
                    },
                    (err) => {
                        this.loading = false;
                        this.$VMessage.error({
                            content: err.message,
                            duration: 30,
                            closable: true,
                        });
                    }
                );
            }
        },
        isDecimalNumber(value) {
            // 检查是否为有效数字（整数或小数）
            return !isNaN(parseFloat(value)) && isFinite(value);
        },
        async submit(value) {
            let bool3 = await this.$refs.editform.validate();
            if (!bool3) {
                return;
            }
            this.formData.status = value;
            if (this.type == "add") {
                this.formData.activityType = this.activityType;
                this.formData.orgId = global.SYSID;
            }
            if (this.type == "edit" || this.type == "add") {
                if (
                    this.formData.activityType == 0 &&
                    (this.formData.discountedBudget == 0 ||
                        !this.isDecimalNumber(this.formData.discountedBudget))
                ) {
                    this.$Message.error("优惠预算请入有效的数字!");
                    return;
                } else if (
                    this.formData.unitAmount == 0 ||
                    !this.isDecimalNumber(this.formData.unitAmount)
                ) {
                    this.$Message.error("金额/百分请输入有效的数字！");
                    return;
                } else if (
                    this.formData.activityType == 2 &&
                    (this.formData.priceBeforeDiscount == 0 ||
                        !this.isDecimalNumber(
                            this.formData.priceBeforeDiscount
                        ))
                ) {
                    this.$Message.error("折扣前价格请输入有效的数字！");
                    return;
                } else if (
                    this.formData.activityType == 2 &&
                    (this.formData.priceAfterDiscount == 0 ||
                        !this.isDecimalNumber(this.formData.priceAfterDiscount))
                ) {
                    this.$Message.error("折扣后价格请输入有效的数字！");
                    return;
                } else if (
                    (this.formData.activityType == 2 ||
                        this.formData.activityType == 3) &&
                    (this.formData.quantity == 0 ||
                        !this.isDecimalNumber(this.formData.quantity))
                ) {
                    this.$Message.error("数量请输入有效的数字！");
                    return;
                }
                if (
                    !this.isDateInRange(this.formData.beginTime) &&
                    this.movementTypeData.dateOptions == 3
                ) {
                    this.$Message.error(
                        "请在" +
                            this.movementTypeData.startDate +
                            "~" +
                            this.movementTypeData.endDate +
                            "范围内选择日期！"
                    );
                    return;
                }
                if (
                    this.formData.activityType != 3 &&
                    !this.isDateInRange(this.formData.beginTime) &&
                    this.movementTypeData.dateOptions == 3
                ) {
                    this.$Message.error(
                        "请在" +
                            this.movementTypeData.startDate +
                            "~" +
                            this.movementTypeData.endDate +
                            "范围内选择日期！"
                    );
                    return;
                }
                if (!this.handleDateTwoChangeA()) return;
            }
            this.loading = true;
            HttpSaveActivityProcess({
                ...this.formData,
            }).then(
                (res) => {
                    this.loading = false;
                    this.$VMessage.success(res.message);
                    this.cancel();
                },
                (err) => {
                    this.loading = false;
                    this.$VMessage.error({
                        content: err.message,
                        duration: 30,
                        closable: true,
                    });
                }
            );
        },
        cancel() {
            this.$router.push({
                name: "activityProcessList",
            });
        },
        mounted() {
            // 添加键盘快捷键 (可选)
            window.addEventListener("keydown", (e) => {
                if (e.key === "0") {
                    this.resetZoom();
                }
            });
        },
    },
};
</script>
<style>
.custom-modal {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 1000;
    display: flex;
    justify-content: center;
    align-items: center;
}

.modal-overlay {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
}

.modal-content {
    position: relative;
    z-index: 1001;
    background: white;
    padding: 20px;
    border-radius: 8px;
    max-width: 90%;
    max-height: 90%;
    overflow: auto;
}

.enhanced-zoom-container {
    position: relative;
    overflow: hidden;
    width: 100%;
    height: 100%;
}

.image-wrapper {
    transition: transform 0.1s;
    will-change: transform;
}

.zoomable-image {
    display: block;
    max-width: 100%;
    max-height: 80vh;
    object-fit: contain;
    user-select: none; /* 防止文本选中 */
    -webkit-user-drag: none; /* Safari */
    -khtml-user-drag: none; /* Konqueror */
    -moz-user-drag: none; /* Firefox */
    -o-user-drag: none; /* Opera */
}

.controls {
    position: absolute;
    bottom: 10px;
    left: 50%;
    transform: translateX(-50%);
    background: rgba(0, 0, 0, 0.6);
    color: white;
    padding: 5px 10px;
    border-radius: 4px;
    display: flex;
    align-items: center;
    gap: 10px;
}

.controls button {
    background: #4a90e2;
    color: white;
    border: none;
    padding: 3px 8px;
    border-radius: 3px;
    cursor: pointer;
}

.controls button:hover {
    background: #3a7bc8;
}
</style>
